import cadespluginInit from "../cadesplugin/cadesplugin_api.js";
import CertificateAdjuster from "../cadesplugin/CertificateAdjuster.js";
import Base64 from "../cadesplugin/Base64.js";

cadespluginInit();

function base64ToHex(str) {
  const raw = atob(str);
  let result = "";
  for (let i = 0; i < raw.length; i++) {
    const hex = raw.charCodeAt(i).toString(16);
    result += hex.length === 2 ? hex : "0" + hex;
  }
  return result.toUpperCase();
}

function cryptoproEsignModel() {
  this.isPluginEnabled = false;
  this.global_selectbox_container = [];
  this.global_isFromCont = [];
  this.global_selectbox_counter = 0;
  this.global_selectedcertID = "";
  this.async_code_included = 0;
  this.async_Promise = null;
  this.async_resolve = null;

  this.Common_CheckForPlugIn = this.Common_CheckForPlugIn.bind(this);
  this.CheckForPlugIn_Async = this.CheckForPlugIn_Async.bind(this);
  this.FillCertInfo_Async = this.FillCertInfo_Async.bind(this);
  this.FillCertList_Async = this.FillCertList_Async.bind(this);
  this.Common_SignCadesBES = this.Common_SignCadesBES.bind(this);
  this.SignCadesBES_Async = this.SignCadesBES_Async.bind(this);
  this.onCertificateSelected = this.onCertificateSelected.bind(this);
  this.SignCadesBES_Async_File = this.SignCadesBES_Async_File.bind(this);
  this.SignHash = this.SignHash.bind(this);
}

cryptoproEsignModel.prototype = {
  Common_CheckForPlugIn: function () {
    var canAsync = !!cadesplugin.CreateObjectAsync;
    if (canAsync) {
      return this.CheckForPlugIn_Async();
    }
  },
  //получение статуса плагина и информации о нем
  CheckForPlugIn_Async: function () {
    var self = this;
    var result = {
      statusCode: "danger",
      statusText: "Плагин не загружен.",
      pluginVersion: "",
      cspName: "",
      cspVersion: "",
    };
    function VersionCompare_Async(StringVersion, ObjectVersion) {
      var result = {};
      if (typeof ObjectVersion == "string") return -1;
      var arr = StringVersion.split(".");
      var isActualVersion = true;

      return cadesplugin.async_spawn(function* () {
        if ((yield ObjectVersion.MajorVersion) == parseInt(arr[0])) {
          if ((yield ObjectVersion.MinorVersion) == parseInt(arr[1])) {
            if ((yield ObjectVersion.BuildVersion) == parseInt(arr[2])) {
              isActualVersion = true;
            } else if ((yield ObjectVersion.BuildVersion) < parseInt(arr[2])) {
              isActualVersion = false;
            }
          } else if ((yield ObjectVersion.MinorVersion) < parseInt(arr[1])) {
            isActualVersion = false;
          }
        } else if ((yield ObjectVersion.MajorVersion) < parseInt(arr[0])) {
          isActualVersion = false;
        }

        if (!isActualVersion) {
          result.statusCode = "warning";
          result.statusText = "Плагин загружен, но есть более свежая версия.";
        }
        result.pluginVersion = yield CurrentPluginVersion.toString();

        var oAbout = yield cadesplugin.CreateObjectAsync("CAdESCOM.About");
        var ver = yield oAbout.CSPVersion("", 80);
        var ret =
          (yield ver.MajorVersion) +
          "." +
          (yield ver.MinorVersion) +
          "." +
          (yield ver.BuildVersion);

        result.cspVersion = ret;
        try {
          var sCSPName = yield oAbout.CSPName(80);
          result.cspName = sCSPName;
        } catch (err) {
          console.log(err);
        }

        return result;
      });
    }

    function GetLatestVersion_Async(CurrentPluginVersion) {
      return new Promise(function (resolve, reject) {
        $.get(
          "https://cryptopro.ru/sites/default/files/products/cades/latest_2_0.txt",
          function (response) {
            resolve(response);
          }
        );
      });
    }

    result.statusCode = "success";
    result.statusText = "Плагин загружен";

    var CurrentPluginVersion, LastPluginVersion;

    return cadesplugin
      .async_spawn(function* () {
        var oAbout = yield cadesplugin.CreateObjectAsync("CAdESCOM.About");
        CurrentPluginVersion = yield oAbout.PluginVersion;
        return;
      })
      .then(function (CurrentPluginVersion) {
        return GetLatestVersion_Async(CurrentPluginVersion);
      })
      .then(function (data) {
        return VersionCompare_Async(data, CurrentPluginVersion);
      })
      .then(function (data) {
        return Object.assign({}, result, data);
      });
  },
  //получение информации о выбранном серификате
  FillCertInfo_Async: function (certificate, certBoxId, isFromContainer) {
    var BoxId;
    var field_prefix;
    if (typeof certBoxId == "undefined" || certBoxId == "CertListBox") {
      BoxId = "cert_info";
      field_prefix = "";
    } else if (certBoxId == "CertListBox1") {
      BoxId = "cert_info1";
      field_prefix = "cert_info1";
    } else if (certBoxId == "CertListBox2") {
      BoxId = "cert_info2";
      field_prefix = "cert_info2";
    } else {
      BoxId = certBoxId;
      field_prefix = certBoxId;
    }
    return cadesplugin.async_spawn(
      function* (args) {
        var Adjust = new CertificateAdjuster();
        var result = {};
        console.log(args);
        var ValidToDate = new Date(yield args[0].ValidToDate);
        var ValidFromDate = new Date(yield args[0].ValidFromDate);
        var Validator;
        var IsValid = false;
        //если попадется сертификат с неизвестным алгоритмом
        //тут будет исключение. В таком сертификате просто пропускаем такое поле
        try {
          Validator = yield args[0].IsValid();
          IsValid = yield Validator.Result;
        } catch (e) { }
        var hasPrivateKey = yield args[0].HasPrivateKey();
        var Now = new Date();
        var pubKey = yield args[0].PublicKey();
        var algo = yield pubKey.Algorithm;
        var fAlgoName = yield algo.FriendlyName;
        // var subject = Adjust.GetCertName(yield args[0].SubjectName);
        var subject = yield args[0].SubjectName;
        var issuer = Adjust.GetIssuer(yield args[0].IssuerName);
        var till = Adjust.GetCertDate(ValidToDate);
        var from = Adjust.GetCertDate(ValidFromDate);
        var algorithm = fAlgoName;

        if (hasPrivateKey) {
          var oPrivateKey = yield args[0].PrivateKey;
          var sProviderName = yield oPrivateKey.ProviderName;

          var provname = sProviderName;

          try {
            var sPrivateKeyLink = yield oPrivateKey.UniqueContainerName;
            result.privateKeyLink = {
              success: true,
              value: sPrivateKeyLink,
            };
          } catch (e) {
            result.privateKeyLink = {
              success: false,
              value: e.message,
            };
          }
        }

        result.status = {
          success: false,
        };
        if (Now < ValidFromDate) {
          result.status.value = "Срок действия не наступил";
        } else if (Now > ValidToDate) {
          result.status.value = "Срок действия истек";
        } else if (!hasPrivateKey) {
          result.status.value = "Нет привязки к закрытому ключу";
        } else if (!IsValid) {
          result.status.value =
            "Ошибка при проверке цепочки сертификатов. Возможно на компьютере не установлены сертификаты УЦ, выдавшего ваш сертификат";
        } else {
          result.status.success = true;
          result.status.value = "Действителен";
        }

        if (args[3]) {
          result.location = {
            success: false,
            value: "Нет",
          };
        } else {
          result.location = {
            success: true,
            value: "да",
          };
        }

        var serial = yield args[0].SerialNumber;

        result.serial = {
          success: !!serial,
          value: serial,
        };
        result.subject = {
          success: !!subject,
          value: subject,
        };
        result.issuer = {
          success: !!issuer,
          value: issuer,
        };
        result.till = {
          success: !!till,
          value: till,
          originValue: yield args[0].ValidToDate,
        };
        result.from = {
          success: !!from,
          value: from,
          originValue: yield args[0].ValidFromDate,
        };
        result.algorithm = {
          success: !!algorithm,
          value: algorithm,
        };
        result.provname = {
          success: !!provname,
          value: provname,
        };

        return result;
      },
      certificate,
      BoxId,
      field_prefix,
      isFromContainer
    );
  },
  //получение списка доступных сертификатов
  FillCertList_Async: function (lstId) {
    var self = this;
    return cadesplugin.async_spawn(function* () {
      var MyStoreExists = true,
        certCnt,
        certs,
        result = [];
      try {
        var oStore = yield cadesplugin.CreateObjectAsync("CAdESCOM.Store");
        if (!oStore) {
          alert("Create store failed");
          return;
        }
        yield oStore.Open();
      } catch (ex) {
        MyStoreExists = false;
      }
      if (MyStoreExists) {
        try {
          certs = yield oStore.Certificates;
          certCnt = yield certs.Count;
        } catch (ex) {
          alert(
            "Ошибка при получении Certificates или Count: " +
            cadesplugin.getLastError(ex)
          );
          return;
        }
        for (var i = 1; i <= certCnt; i++) {
          var cert;
          try {
            cert = yield certs.Item(i);
          } catch (ex) {
            alert(
              "Ошибка при перечислении сертификатов: " +
              cadesplugin.getLastError(ex)
            );
            return;
          }
          var oOpt = {};
          var dateObj = new Date();
          try {
            var ValidFromDate = new Date(yield cert.ValidFromDate);
            oOpt.text = new CertificateAdjuster().GetCertInfoString(
              yield cert.SubjectName,
              ValidFromDate
            );
          } catch (ex) {
            alert(
              "Ошибка при получении свойства SubjectName: " +
              cadesplugin.getLastError(ex)
            );
          }

          try {
            oOpt.value = self.global_selectbox_counter;
            self.global_selectbox_container.push(cert);
            self.global_isFromCont.push(false);
            self.global_selectbox_counter++;
          } catch (ex) {
            console.log(ex);
            alert(
              "Ошибка при получении свойства Thumbprint: " +
              cadesplugin.getLastError(ex)
            );
          }
          result.push(oOpt);
        }
        yield oStore.Close();
      }

      //В версии плагина 2.0.13292+ есть возможность получить сертификаты из
      //закрытых ключей и не установленных в хранилище
      try {
        yield oStore.Open(cadesplugin.CADESCOM_CONTAINER_STORE);
        certs = yield oStore.Certificates;
        certCnt = yield certs.Count;
        for (var i = 1; i <= certCnt; i++) {
          var cert = yield certs.Item(i);
          //Проверяем не добавляли ли мы такой сертификат уже?
          var found = false;
          for (var j = 0; j < self.global_selectbox_container.length; j++) {
            if (
              (yield self.global_selectbox_container[j].Thumbprint) ===
              (yield cert.Thumbprint)
            ) {
              found = true;
              break;
            }
          }
          if (found) continue;
          var oOpt = {};
          var ValidFromDate = new Date(yield cert.ValidFromDate);
          oOpt.text = new CertificateAdjuster().GetCertInfoString(
            yield cert.SubjectName,
            ValidFromDate
          );
          oOpt.value = global_selectbox_counter;
          self.global_selectbox_container.push(cert);
          self.global_isFromCont.push(true);
          self.global_selectbox_counter++;
          result.push(oOpt);
        }
        yield oStore.Close();
      } catch (ex) {
        console.log(ex);
      }
      if (!self.global_selectbox_container.length) {
        return [];
      } else {
        return result;
      }
    });
  },
  //общая функция для подписи
  Common_SignCadesBES: function (data, type = "string") {
    var canAsync = !!cadesplugin.CreateObjectAsync;
    if (canAsync) {
      return type === "file"
        ? this.SignCadesBES_Async_File(data)
        : this.SignCadesBES_Async(data);
    } else {
      throw new Error("Нет поддрежки ассинхронности");
    }
    // else {
    // 	return SignCadesBES_NPAPI(id, text, setDisplayData);
    // }
  },
  //асинхронная функция для подписи
  SignCadesBES_Async: function (data, setDisplayData) {
    var self = this;
    return cadesplugin.async_spawn(function* (arg) {
      var certificate =
        self.global_selectbox_container[self.global_selectedcertID];
      if (!certificate) {
        alert("Select certificate");
        return;
      }
      if (!data) {
        return;
      }

      var dataToSign = Base64.encode(data);

      var Signature;
      try {
        var errormes = "";
        try {
          var oSigner = yield cadesplugin.CreateObjectAsync(
            "CAdESCOM.CPSigner"
          );
        } catch (err) {
          errormes = "Failed to create CAdESCOM.CPSigner: " + err.number;
          throw errormes;
        }
        var oSigningTimeAttr = yield cadesplugin.CreateObjectAsync(
          "CADESCOM.CPAttribute"
        );

        yield oSigningTimeAttr.propset_Name(
          cadesplugin.CAPICOM_AUTHENTICATED_ATTRIBUTE_SIGNING_TIME
        );
        var oTimeNow = new Date();
        yield oSigningTimeAttr.propset_Value(oTimeNow);
        var attr = yield oSigner.AuthenticatedAttributes2;
        yield attr.Add(oSigningTimeAttr);

        var oDocumentNameAttr = yield cadesplugin.CreateObjectAsync(
          "CADESCOM.CPAttribute"
        );
        yield oDocumentNameAttr.propset_Name(
          cadesplugin.CADESCOM_AUTHENTICATED_ATTRIBUTE_DOCUMENT_NAME
        );
        yield oDocumentNameAttr.propset_Value("Document Name");
        yield attr.Add(oDocumentNameAttr);

        if (oSigner) {
          yield oSigner.propset_Certificate(certificate);
        } else {
          errormes = "Failed to create CAdESCOM.CPSigner";
          throw errormes;
        }

        var oSignedData = yield cadesplugin.CreateObjectAsync(
          "CAdESCOM.CadesSignedData"
        );
        if (dataToSign) {
          // Данные на подпись ввели
          yield oSigner.propset_Options(
            cadesplugin.CAPICOM_CERTIFICATE_INCLUDE_WHOLE_CHAIN
          );
          yield oSignedData.propset_ContentEncoding(
            cadesplugin.CADESCOM_BASE64_TO_BINARY
          ); //
          if (typeof setDisplayData != "undefined") {
            //Set display data flag flag for devices like Rutoken PinPad
            yield oSignedData.propset_DisplayData(1);
          }
          yield oSignedData.propset_Content(dataToSign);

          try {
            Signature = yield oSignedData.SignCades(
              oSigner,
              cadesplugin.CADESCOM_CADES_BES
            );
          } catch (err) {
            errormes =
              "Не удалось создать подпись из-за ошибки: " +
              cadesplugin.getLastError(err);
            throw errormes;
          }
        }
        return {
          success: true,
          signature: Signature,
          text: "Подпись сформирована успешно",
        };
      } catch (err) {
        return {
          success: false,
          signature: Signature,
          text: err,
        };
      }
    }); //cadesplugin.async_spawn
  },
  //асинхронная функция для подписи файла
  SignCadesBES_Async_File: function (dataToSign, isBase64) {
    var certificate =
      this.global_selectbox_container[this.global_selectedcertID];
    dataToSign = isBase64 ? dataToSign : Base64.encode(dataToSign);

    return cadesplugin.async_spawn(function* () {
      var Signature;
      try {
        //FillCertInfo_Async(certificate);
        var errormes = "";
        try {
          var oSigner = yield cadesplugin.CreateObjectAsync(
            "CAdESCOM.CPSigner"
          );
        } catch (err) {
          console.log(err);
          errormes = "Failed to create CAdESCOM.CPSigner: " + err.number;
          throw errormes;
        }
        var oSigningTimeAttr = yield cadesplugin.CreateObjectAsync(
          "CADESCOM.CPAttribute"
        );
        var CAPICOM_AUTHENTICATED_ATTRIBUTE_SIGNING_TIME = 0;
        yield oSigningTimeAttr.propset_Name(
          CAPICOM_AUTHENTICATED_ATTRIBUTE_SIGNING_TIME
        );
        var oTimeNow = new Date();
        yield oSigningTimeAttr.propset_Value(oTimeNow);
        var attr = yield oSigner.AuthenticatedAttributes2;
        yield attr.Add(oSigningTimeAttr);
        var oDocumentNameAttr = yield cadesplugin.CreateObjectAsync(
          "CADESCOM.CPAttribute"
        );
        var CADESCOM_AUTHENTICATED_ATTRIBUTE_DOCUMENT_NAME = 1;
        yield oDocumentNameAttr.propset_Name(
          CADESCOM_AUTHENTICATED_ATTRIBUTE_DOCUMENT_NAME
        );
        yield oDocumentNameAttr.propset_Value("Document Name");
        yield attr.Add(oDocumentNameAttr);
        if (oSigner) {
          yield oSigner.propset_Certificate(certificate);
        } else {
          errormes = "Failed to create CAdESCOM.CPSigner";
          throw errormes;
        }
        var oSignedData = yield cadesplugin.CreateObjectAsync(
          "CAdESCOM.CadesSignedData"
        );
        var CADES_BES = 1;
        if (dataToSign) {
          // Данные на подпись ввели
          yield oSignedData.propset_ContentEncoding(1); //CADESCOM_BASE64_TO_BINARY
          yield oSignedData.propset_Content(dataToSign);
          yield oSigner.propset_Options(1); //CAPICOM_CERTIFICATE_INCLUDE_WHOLE_CHAIN
          try {
            var StartTime = Date.now();
            Signature = yield oSignedData.SignCades(oSigner, CADES_BES);
            $('[name="TimeTitle"]').html(
              "Время выполнения: " + (Date.now() - StartTime) + " мс"
            );
          } catch (err) {
            errormes =
              "Не удалось создать подпись из-за ошибки: " +
              cadesplugin.getLastError(err);
            throw errormes;
          }
        }
        return {
          success: true,
          signature: Signature,
          text: "Подпись сформирована успешно",
        };
      } catch (err) {
        return {
          success: false,
          signature: Signature,
          text: err,
        };
      }
    });
  },

  SignHash(sHashValue) {
    var certificate = this.global_selectbox_container[this.global_selectedcertID];

    // список алгоритмов хеширования
    // CADESCOM_HASH_ALGORITHM_CP_GOST_3411	Алгоритм ГОСТ Р 34.11-94.	100
    // CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_256	Алгоритм ГОСТ Р 34.11-2012.	101
    // CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_256_HMAC	Алгоритм ГОСТ Р 34.11-2012 HMAC.	111
    // CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_512	Алгоритм ГОСТ Р 34.11-2012.	102
    // CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_512_HMAC	Алгоритм ГОСТ Р 34.11-2012 HMAC.	112
    // CADESCOM_HASH_ALGORITHM_CP_GOST_3411_HMAC	Алгоритм ГОСТ Р 34.11-94 HMAC.	110

    return cadesplugin.async_spawn(function* () {
      try {
        var oSigner = yield cadesplugin.CreateObjectAsync("CAdESCOM.CPSigner");

        yield oSigner.propset_Certificate(certificate);
        // yield oSigner.propset_CheckCertificate(true);

        var oSignedData = yield cadesplugin.CreateObjectAsync(
          "CAdESCOM.CadesSignedData"
        );
        // yield oSignedData.propset_DataEncoding(
        //   cadesplugin.CADESCOM_BASE64_TO_BINARY
        // );
        yield oSignedData.propset_DataEncoding = cadesplugin.CADESCOM_BASE64_TO_BINARY;

        var hashAlg = cadesplugin.CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_256;
        var oHashedData = yield cadesplugin.CreateObjectAsync(
          "CAdESCOM.HashedData"
        );
        ;
        yield oHashedData.propset_DataEncoding(cadesplugin.CADESCOM_BASE64_TO_BINARY);
        yield oHashedData.propset_Algorithm(hashAlg);
        yield oHashedData.SetHashValue(sHashValue);

        var sRawSignature = yield oSignedData.SignHash(
          oHashedData,
          oSigner,
          cadesplugin.CADESCOM_CADES_BES
        );

        return {
          text: "Подпись успешно сформирована",
          signature: sRawSignature,
          success: true,
        };
      } catch (err) {
        return {
          text:
            "Failed to create signature. Error: " +
            cadesplugin.getLastError(err),
          signature: sRawSignature,
          success: false,
        };
      }
    });
  },

  CoSignHash(sSignedMessage, sHashValue, fileBase64) {
    var certificate = this.global_selectbox_container[this.global_selectedcertID];
    return cadesplugin.async_spawn(function* () {
      try {
        // console.log(fileBase64);
        // var oHashedData = yield cadesplugin.CreateObjectAsync("CAdESCOM.HashedData");
        // oHashedData.propset_Algorithm(cadesplugin.CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_256);
        // yield oHashedData.propset_DataEncoding(cadesplugin.CADESCOM_BASE64_TO_BINARY);
        // yield oHashedData.Hash(fileBase64);
        // var sHashValue1 = yield oHashedData.Value;
        // console.log(sHashValue1);
        // return;

        var oSigner = yield cadesplugin.CreateObjectAsync("CAdESCOM.CPSigner");
        yield oSigner.propset_Certificate(certificate);
        yield oSigner.propset_CheckCertificate(true);

        var oHashedData = yield cadesplugin.CreateObjectAsync("CAdESCOM.HashedData");
        var hashAlg = cadesplugin.CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_256;
        yield oHashedData.propset_DataEncoding(cadesplugin.CADESCOM_BASE64_TO_BINARY);
        yield oHashedData.propset_Algorithm(hashAlg);
        yield oHashedData.SetHashValue(sHashValue);

        var oSignedData = yield cadesplugin.CreateObjectAsync("CAdESCOM.CadesSignedData");
        
        oSignedData.VerifyHash(oHashedData, sSignedMessage, cadesplugin.CADESCOM_CADES_BES);

        var newSignedMessage = oSignedData.CoSignHash(oHashedData, oSigner, cadesplugin.CADESCOM_CADES_BES);

        return {
          text: "Подпись успешно сформирована",
          signature: newSignedMessage,
          success: true,
        };

      } catch (err) {
        return {
          text:
            "Failed to create signature. Error: " +
            cadesplugin.getLastError(err),
          signature: '',
          success: false,
        };
      }
    });
  },

  hasCertId() {
    return parseInt(this.global_selectedcertID) >= 0;
  },

  //обработчик на селект выбора сертификата, принимает сам элемент селекта по нему определяет выбранный
  onCertificateSelected: function (target) {
    var self = this;

    return cadesplugin.async_spawn(function* (args) {
      var selectedCertID = args[0].selectedIndex;
      self.global_selectedcertID = args[0][selectedCertID].value;
      var certificate =
        self.global_selectbox_container[self.global_selectedcertID];

      return self.FillCertInfo_Async(
        certificate,
        target.boxId,
        self.global_isFromCont[selectedCertID]
      );
    }, target);
  },
};

export default cryptoproEsignModel;
